import styled from 'styled-components';
import colors from '../../../styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;

	& > * + * {
		margin-top: 1rem;
		padding-top: 1rem;
		border-top: 1px solid ${colors.neutralForm};
	}

	.file-wrapper {
		display: flex;
		flex-direction: column;

		&__heading {
			display: flex;
			justify-content: space-between;

			a {
				text-decoration: none;
			}
		}

		&__body {
			margin-top: 0.5rem;

			& > * + * {
				margin-top: 0.75rem;
			}
		}

		&__title {
			color: ${colors.neutralText};
		}

		&__value {
			margin-top: 0.25rem;
		}
	}
`;

export const Form = styled.form`
	position: relative;
	padding: 3rem 1.25rem 0;

	.close-button {
		position: absolute;
		top: 1rem;
		right: 1rem;
		color: ${colors.neutralButton};
	}
`;

export const InfoWrapper = styled.div`
	margin: 0 auto 0.75rem;
	width: 100%;
	max-width: 34.5rem;

	& > * + * {
		margin-top: 0.75rem;
	}
`;

export const FieldsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 1.5rem;
	width: 100%;
	max-width: 29rem;
	margin: 2rem auto 0;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin: 1.75rem -1.25rem 0;
	padding: 1rem;
	border-top: 1px solid ${colors.neutralForm};

	& > * + * {
		margin-left: 1rem;
	}
`;

export const FilesListWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 1rem;

	.files-wrapper {
		display: grid;
		grid-template-columns: 1fr;
		gap: 1rem;

		header {
			display: flex;
			justify-content: space-between;
			align-items: center;

			button {
				color: ${colors.neutralText};
			}
		}

		&__item {
			display: grid;
			grid-template-columns: 1fr;
			gap: 1rem;
			padding-bottom: 1.5rem;
			border-bottom: 1px solid ${colors.neutralForm};

			&__info {
				h6 {
					color: ${colors.neutralText};
					margin-bottom: 0.375em;
				}
			}

			&__details {
				display: flex;
				align-items: center;

				& > div {
					margin-left: 0.5rem;

					& > p:last-child {
						color: ${colors.neutralText};
					}
					& > p:first-child {
						color: #000;
					}
				}
			}

			&:last-child {
				padding-bottom: 0;
				border-bottom: none;
			}
		}
	}
`;

export const FileListDropzone = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	border: 1px dashed ${colors.neutralText};
	height: 12.5rem;
	border-radius: 0.375rem;
	cursor: pointer;

	overflow: hidden;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.upload-placeholder {
		display: grid;
		grid-template-columns: 1fr;
		gap: 0.5rem;

		&__picture {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 0.375rem;
			padding: 0.5rem;
			width: 100%;
			max-width: 8.25rem;
			margin: 1rem auto 0;
			background-color: ${colors.neutralMessage};
			color: ${colors.brandPrimary};
		}

		&__paragraph {
			color: ${colors.neutralText};

			strong {
				color: ${colors.brandPrimary};
			}
		}
	}

	${({ isDragActive }) =>
		isDragActive &&
		css`
			opacity: 0.8;
		`}

	${({ isDragAccept }) =>
		isDragAccept &&
		css`
			border-color: ${colors.stateSuccess};
		`}

	${({ isDragReject }) =>
		isDragReject &&
		css`
			border-color: ${colors.stateDanger};
		`}
`;
